import React from "react";
import TimeAgo from "react-timeago";
import { NotificationEnums } from "../helpers/NotificationHelpers";

const NotificationItem = ({ notification, onAction }) => {
  const notificationData = notification;
  const notificationColor = NotificationEnums.getColor(
    notificationData.notification_type
  );
  const notificationImage = NotificationEnums.getImage(
    notificationData.notification_type
  );
  const notificationAction = NotificationEnums.getAction(
    notificationData.notification_type
  );

  const handleNotificationClick = () => {
    console.log(`Tapped Action Button: ${notificationData.requestedUser}`);
    onAction(notificationData);
  };

  return (
    <div className="px-4 md:px-6 py-2 mb-2 bg-white border border-slate-300 rounded-xl flex flex-row justify-start items-center">
      <img
        className="h-8 w-8 object-contain"
        src={notificationImage}
        alt="Notification"
      />
      <div className="flex flex-col justify-center items-start ml-3">
        <p className="text-sm md:text-base pb-0 mb-0">
          {notificationData.notification_content}
        </p>
        <p className="pb-0 mb-0" style={{ fontSize: 12 }}>
          <TimeAgo
            date={notificationData?.createdAt ?? new Date().toISOString()}
          />
        </p>
      </div>

      <div style={{ flex: 1 }} />
      {notification.notification_type !== 3 && (
        <div
          className="px-4 md:px-8 py-2 rounded-lg cursor-pointer"
          onClick={handleNotificationClick}
          style={{
            backgroundColor: `${notificationColor}40`,
          }}
        >
          <p
            className="w-20 font-medium text-center text-sm"
            style={{ color: notificationColor }}
          >
            {notificationAction}
          </p>
        </div>
      )}
    </div>
  );
};

export default NotificationItem;
